'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { SUB_DOMAIN } from '@/constants';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
interface Card {
  image: number;
  href: string;
  target?: string;
}
const STATIC_BANNERS = {
  '사장님 카드': {
    image: 1,
    href: '/community/policyInfo/f75177be-4665-4cb8-b6c3-f23e71555322'
  },
  'K 패스': {
    image: 2,
    href: 'https://www.ibk.co.kr/cardbiz/detailBizNew.ibk?PDLN_CD=12&PDGR_CD=11&PDTM_CD=258&PDCD=0004&mz_cd=ADGROUN&ad_cd=wello',
    target: '_blank'
  },
  디지털서비스개방만족도조사: {
    image: 4,
    href: 'http://survey.wowsurvey.com/mois',
    target: '_blank'
  }
} as Record<string, Card & {
  expiredAt?: string;
}>;
type StaticBannerList = keyof typeof STATIC_BANNERS;
interface StaticBannerProps {
  bannerList: StaticBannerList[];
  className?: string;
}
export const StaticBanner = t0 => {
  const $ = _c(15);
  const {
    bannerList,
    className
  } = t0;
  const subDomain = useDeviceInfoStore(_temp);
  let t1;
  if ($[0] !== subDomain) {
    t1 = banner => {
      if (banner === "K \uD328\uC2A4" && subDomain === SUB_DOMAIN.KB_PAY) {
        return false;
      }
      return true;
    };
    $[0] = subDomain;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const filteredBannerList = bannerList.filter(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Autoplay({
      delay: 5000,
      stopOnInteraction: false
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const autoplayPlugin = t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      loop: true,
      align: "start"
    };
    t4 = [autoplayPlugin];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  const [emblaRef] = useEmblaCarousel(t3, t4);
  let t5;
  if ($[5] !== className) {
    t5 = cn("w-full overflow-hidden rounded-small", className);
    $[5] = className;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = "relative overflow-hidden";
  const t7 = "flex gap-8";
  const t8 = filteredBannerList.map(_temp2);
  let t9;
  if ($[7] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== emblaRef || $[10] !== t9) {
    t10 = <div className={t6} ref={emblaRef}>{t9}</div>;
    $[9] = emblaRef;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t5) {
    t11 = <section className={t5}>{t10}</section>;
    $[12] = t10;
    $[13] = t5;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
};
function _temp(state) {
  return state.subDomain;
}
function _temp2(banner_0) {
  const item = STATIC_BANNERS[banner_0];
  const target = "target" in item ? item.target : undefined;
  return <div key={banner_0} className="min-w-0 flex-[0_0_100%]"><CustomLink aria-label={banner_0} href={item.href} target={target}><Image alt={banner_0} height={203} src={`/assets/pngs/banner/${item.image}.png`} width={810} /></CustomLink></div>;
}